//React
import React from 'react';
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as myQaQuestionAction from '../action/myQaQuestionAction';

//Material-ui
//Icon
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
//Part

//Dialog
import DialogMyQaQuestionStatisticsUser from './DialogMyQaQuestionStatisticsUser';

class Comp extends React.Component {

  constructor(props) {
    super(props);

    let sum = 0;
    props.statistics.forEach(function(value) {
      sum += value.answer_cnt;
    });
    this.state = {
      sum: sum,
      statisticsUserAnswerComment: null,
  	}
  }

  _answerStatisticsUserToggle(visible, qaId, answerText) {
    if (visible) {
      this.props.myQaQuestionStatisticsUserDel(qaId, answerText);
    }
    else {
      this.props.myQaQuestionStatisticsUserGet(qaId, answerText, 1, () => {
        console.log('call');
      });
    }
  }

  _onPaging(qaId, answerText, page) {
    this.props.myQaQuestionStatisticsUserGet(qaId, answerText, page, () => {
      console.log('call');
    });
  }

  _renderGraph(value, index) {
    let width = 0;

    width = Math.round((value.answer_cnt / this.state.sum) * 100);

    return (
      <div
        key={index}
        style={{margin:'5px'}}
      >
        <div
          style={{
            backgroundColor: '#FFBC57',
            color:'#FFF',
            width: width + '%',
            minWidth:'50px',
            cursor:'pointer',
            textAlign:'right',
            padding:'2px',
          }}
          className='round12'
          onClick={
            () => this.setState({
              statisticsUserAnswerComment: value.answer_comment,
            })
          }
        >
          {value.answer_cnt}
          <ArrowRightIcon style={{verticalAlign:'middle'}}/>
        </div>
        {value.answer_comment}

      </div>
    )
  }


	render() {
		return (
			<div>
        {
          this.props.statistics.map((value, index) =>
            this._renderGraph(value, index)
          )
        }
        <DialogMyQaQuestionStatisticsUser
          open={(this.state.statisticsUserAnswerComment) ? true : false}
          close={
            () => this.setState({
              statisticsUserAnswerComment: null,
            })
          }
          qaId={this.props.qaId}
          answerComment={this.state.statisticsUserAnswerComment}
        />
			</div>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
		...myQaQuestionAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
